'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		// fe templates
		if (document.body.classList.contains('page-template-fe-page-services')) {
			this.setupTabs('.js-tabs__container', '.js-tabs__navigation', '.js-tabs__section');
			this.setupTabs('.js-tabs__container--alt', '.js-tabs__navigation--alt', '.js-tabs__section--alt');
		} else { // be templates
			const tabContainers = document.querySelectorAll('.js-tabs__container');
			if (tabContainers) {
				for (let i = 0; i < tabContainers.length; i++) {
					const count = tabContainers[i].getAttribute('data-count');
					Tabs.setupTabs(`.js-tabs__container[data-count="${count}"]`, `.js-tabs__navigation[data-count="${count}"]`, `.js-tabs__section[data-count="${count}"]`);
				}
			}
		}
	},

	setupTabs: function(containerClass, navigationClass, sectionClass) {
		const container = document.querySelector(containerClass);
		if (!container) return;

		const tabs = container.querySelectorAll(navigationClass + ' .js-tabs__navigation-item');
		const sections = container.querySelectorAll(sectionClass);

		if (tabs.length === 0 || sections.length === 0) return;

		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => {
				tabs.forEach(t => t.classList.remove('active'));
				sections.forEach(s => s.classList.remove('active'));

				tab.classList.add('active');
				sections[index].classList.add('active');
			});
		});
	}
};


export default Tabs;
